<template>
  <v-app>
    <v-content id="login" :bg="false">
      <vue-particles color="#000044" :particle-opacity="0.3" :particles-number="120" shape-type="circle"
        :particle-size="6" lines-color="#A0A0A0" :lines-width="2" :line-linked="true" :line-opacity="0.4"
        :lines-distance="100" :move-speed="3" :hover-effect="true" hover-mode="grab" :click-effect="true"
        click-mode="repulse" />
    </v-content>
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="4" lg="3">
          <v-alert v-model="showError" type="error" dismissible>
            {{ this.errormm }}
          </v-alert>
          <v-alert v-model="successBool" type="success" dismissible transition="scale-transition">
            {{ this.successMsg }}
          </v-alert>

          <v-card class="elevation-9 pa-3" color="#ffffff">
            <v-card-text>
              <div class="layout column align-center">
                <img src="../../../assets/MastersLogo.jpg" alt="MastersAudio logo" width="320" height="320" />
                <h1 class="flex my-4 primary--text">
                  ආයුබෝවන් !
                </h1>
              </div>
              <!-- <v-form>
                <v-text-field
                  v-model="email"
                  append-icon="person"
                  name="email"
                  label="User Name"
                />
                <v-text-field
                  id="password"
                  v-model="password"
                  append-icon="lock"
                  name="password"
                  label="Password"
                  type="password"
                  @keyup.enter.native="login"
                />
              </v-form> -->
              <v-form>
                <br />
                <v-btn large class="mb-1" block style="background-color:#3f852b; color: white; font-size: large;"
                  @click="googleLogin">Sign
                  in with Google</v-btn>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <!-- <v-btn block color="primary" @click="login">
                Login
              </v-btn> -->
            </v-card-actions>
            <!-- <v-card-actions>
              <v-card-text class="text-lg-center text-sm-center">
                OR
              </v-card-text>
            </v-card-actions>
            <v-card-actions>
              <v-btn block outlined color="red" disabled @click="googleLogin">
                <img
                  src="../../../assets/google.svg"
                  alt="DUC logo"
                  width="20"
                  height="20"
                />Google Signin
              </v-btn>
            </v-card-actions>
            <v-card-actions>
              <v-btn block color="warning" disabled @click="register">
                Register
              </v-btn>
            </v-card-actions>
            <a @click="reset">Reset Password</a> -->
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-dialog v-model="loading" persistent width="200">
          <v-card>
            <v-card-text>
              <v-container>
                <v-row class="justify-center">
                  Loging in...
                </v-row>
                <v-row class="mt-2 justify-center">
                  <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
/* eslint-disable no-unused-vars */
import db from './api/firebaseInit';
import firebase from 'firebase';
import Vue from 'vue';
import VueCookies from 'vue-cookies';
import VueParticles from 'vue-particles';
import VueSimpleAlert from 'vue-simple-alert';
Vue.use(VueSimpleAlert);
Vue.use(VueParticles);
Vue.use(VueCookies);
export default {
  data: () => ({
    loading: false,
    email: '',
    password: '',
    showError: false,
    errormm: ' ',
    successMsg: '',
    successBool: false,
    supers: ['e17imk5j4Fe8tEv1D4w271NgmEt2', '0hMbYlvWcHRdcIgJJcA2UouFcMI2']
  }),
  // watch: {
  //   loader () {
  //     const l = this.loader
  //     this[l] = !this[l]
  //     setTimeout(() => {
  //       this[l] = false
  //     }, 3000)
  //     this.loader = null
  //   },
  // },
  mounted() {
    // //console.log(VueCookies.isKey('user'));
    this.showError = false;
    this.successBool = false;
    if (VueCookies.isKey('user')) {
      // check if logged in
      this.$router.push('/');
    }
  },
  methods: {
    login: function (e) {
      let newEmail = this.email + '@ucsc.lk';
      this.loading = true;
      // console.log(this.email)

      firebase
        .auth()
        .signInWithEmailAndPassword(newEmail, this.password)
        .then(
          (user) => {
            VueCookies.config('1y');
            this.showError = false;
            this.successMsg = 'Login Success';
            this.successBool = true;
            const uid = firebase.auth().currentUser.uid;
            // console.log(uid)

            const userDetails = db
              .collection('userDetails')
              .doc(uid)
              .get()
              .then((doc) => {
                if (doc.exists) {
                  // e = doc.data().folderName
                  VueCookies.set('user', uid);
                  VueCookies.set('name', doc.data().Name);
                  if (doc.data().Admin) {
                    VueCookies.set('admin', doc.data().Admin);
                  }
                  VueCookies.set('userEmail', newEmail);
                  this.$router.push('/');
                  this.loading = false;
                } else {
                  this.successBool = false;
                  this.$alert('Contact Admin', '', 'warning');
                  this.loading = false;
                  this.$router.push('/Login');
                }
              })
              .catch((err) => {
                const error = err;
                this.loading = false;
                this.$alert('Went to catch', '', 'error');
                // //console.log('Error getting document', err);
              });
          },
          (err) => {
            // alert(err.message);
            // this.errormm = err.message
            // this.showError = true
            this.$alert(err.message, '', 'error');
            this.loading = false;
            this.$router.push('/Login');
          }
        );
      e.preventDefault();
    },
    register: function (e) {
      //   this.$router.push('/register')
    },
    reset: function (e) {
      this.$alert('Contact Admin', '', 'warning');
      //   const auth = firebase.auth()
      //   const emailAddress = this.email
      //   //console.log(this.email)

      //   auth.sendPasswordResetEmail(emailAddress).then(() => {
      //     // Email sent.
      //     // //console.log('sent');
      //     // alert('Success! Please check your email inbox');
      //     this.$alert('Success!', 'Please check your email inbox', 'success')
      //   }).catch(err => {
      //     const error = err
      //     this.$alert('Error!', 'Please check your email', 'error')
      //   // //console.log('Error getting document', err);
      //   })
    },
    googleLogin: function (e) {
      const provider = new firebase.auth.GoogleAuthProvider()
      firebase
        .auth()
        .signInWithPopup(provider)
        .then(
          user => {
            VueCookies.config('1y');
            this.showError = false;
            this.successMsg = 'Login Success';
            this.successBool = true;
            const uid = firebase.auth().currentUser.uid;
            // const userDetails = db
            //   .collection('userDetails')
            //   .doc(uid)
            //   .get()
            //   .then((doc) => {
            //     if (doc.exists) {
            //       // e = doc.data().folderName
            VueCookies.set('name', firebase.auth().currentUser.displayName);
            VueCookies.set('user', uid);
            if (this.supers.includes(uid)) {
              VueCookies.set('maman', true);
            }
            //       VueCookies.set('userEmail', newEmail);
            this.$router.push('/');
            //     this.loading = false;
            //   } else {
            //     this.successBool = false;
            //     this.$alert('Contact Admin', '', 'warning');
            //     this.loading = false;
            //     this.$router.push('/Login');
            //   }
            // })
            // .catch((err) => {
            //   const error = err;
            //   this.loading = false;
            //   this.$alert('Went to catch', '', 'error');
            //   // //console.log('Error getting document', err);
            // });
          },
          err => {
            // alert(err.message);
            this.errormm = err.message
            this.showError = true
          },
        )
      e.preventDefault()
    },
  },
};
</script>
<style scoped lang="css">
#login {
  height: 50%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  content: '';
  z-index: 0;
}

.centered-input input {
  text-align: center;
}
</style>
